import IOffer from './IOffer';

const getDefaultOffer = (): IOffer => ({
  address: '',
  attachmentsNote: '',
  buildingType: '',
  cargo: '',
  city: '',
  collateral: '',
  collateralAmount: '',
  collateralPercentage: '',
  contractType: '',
  country: 'Suomi',
  created: null,
  createdUser: null,
  customer: '',
  customerMark: '',
  deliveryTimeNote: '',
  designer: '',
  electronicInvoicingAddress: '',
  electronicInvoicingOperator: '',
  electronicInvoicingOperatorId: '',
  employeeInformationType: '',
  invoiceNote: '',
  invoiceReference: '',
  jobType: '',
  language: '',
  offerText: '',
  deliveryTerms: '',
  offerType: '',
  orderNumber: '',
  organizationUnit: null,
  sentAt: null,
  sentUser: null,
  status: '',
  target: '',
  taxRate: '',
  updated: null,
  updatedUser: null,
  validity: '',
  wayOfReceivingType: '',
  worksiteKey: '',
  zipCode: '',
});

export default getDefaultOffer;
